export var MediaInputErrors;
(function (MediaInputErrors) {
    MediaInputErrors[MediaInputErrors["NotAllowedError"] = 1] = "NotAllowedError";
    MediaInputErrors[MediaInputErrors["NotFoundError"] = 2] = "NotFoundError";
    MediaInputErrors[MediaInputErrors["OverconstrainedError"] = 3] = "OverconstrainedError";
    MediaInputErrors[MediaInputErrors["UnrecognizedError"] = 4] = "UnrecognizedError";
})(MediaInputErrors || (MediaInputErrors = {}));
